export interface NavLink {
  label: string;
  href: string;
  children?: NavLink[];
}

export const navLinks: NavLink[] = [
  { label: '首页', href: '/' },
  { label: '在线学习', href: '/category/online-learning' },
  { label: '设计工具', href: '/category/design-tools' },
  { label: '开发工具', href: '/category/dev-tools' },
  { label: 'AI工具', href: '/category/ai-tools' },
  { label: '更多分类', href: '#', children: [
    { label: '影视娱乐', href: '/category/entertainment' },
    { label: '办公效率', href: '/category/productivity' },
    { label: '图片素材', href: '/category/stock-images' },
    { label: '音频音乐', href: '/category/audio-music' },
  ]},
];

export const footerLinks = {
  categories: [
    { label: '在线学习资源', href: '/category/online-learning' },
    { label: '设计工具资源', href: '/category/design-tools' },
    { label: '开发工具资源', href: '/category/dev-tools' },
    { label: 'AI工具资源', href: '/category/ai-tools' },
    { label: '影视娱乐资源', href: '/category/entertainment' },
    { label: '办公效率工具', href: '/category/productivity' },
    { label: '图片素材资源', href: '/category/stock-images' },
    { label: '音频音乐资源', href: '/category/audio-music' },
  ],
  quickLinks: [
    { label: '关于我们', href: '/about' },
    { label: '热门资源', href: '/#featured' },
    { label: '最新文章', href: '/#latest' },
    { label: '常见问题', href: '/#faq' },
  ],
};